<template>
    <div>

        <section class="content-section " data-background="images/section-bg01.png" data-stellar-background-ratio="0.8">
            <div class="container contact">
                <div class="row">
                    <div class="col-12 txt">
                        <div class="section-title">
                            <h2>Contact us</h2>

                        </div>
                        <!-- end section-title -->
                    </div>
                    <!-- end col-12 -->
                    <div class="col-lg-10 offset-lg-2 txt">
                        <div class="row inner">


                            <div class="col-lg-4">
                                <div class="contact-box">
                                    <figure><img :src="'/static/img/icon-location.png'" alt="Image"></figure>
                                    <h6>Address:</h6>
                                  <p>Shamal Communications <br>
                                    Office 3208, Indigo Icon Tower, <br> Cluster F, Jumeirah Lakes Towers
                                    <br>


                                        Dubai, United Arab Emirates


                                        </p>
                                   <div class="social-media">
                    <ul>
                        <li><a href="https://www.linkedin.com/company/shamal-marketing-communications/" target="_blank"><i class="lni lni-linkedin-original" ></i></a></li>
                        <li><a href="https://www.facebook.com/shamalcomms" target="_blank"><i class="lni lni-facebook-filled" ></i></a></li>
                        <li><a href="https://twitter.com/shamalcomms" target="_blank"><i class="lni lni-twitter-original"></i></a></li>
                        <li><a href="https://www.instagram.com/shamalcomms/" target="_blank"><i class="lni lni-instagram"></i></a></li>
                    </ul>
                </div>
                                </div>
                                <!--end contact-box -->
                            </div>
                            <!-- end col-4 -->
                            <div class="col-lg-3">
                                <div class="contact-box">
                                    <figure><img :src="'/static/img/icon-phones.png'" alt=""></figure>
                                    <h6>Phone:</h6>
                                    <p> +971 4 365 2711<br>
                                    </p>
                                </div>
                                <!--end contact-box -->
                            </div>
                            <!-- end col-4 -->
                            <div class="col-lg-4">
                                <div class="contact-box">
                                    <figure><img :src="'/static/img/icon-email.png'" alt=""></figure>
                                    <h6>E-mail:</h6>
                                    <a href="mailto:shamal@shamalcomms.com">shamal@shamalcomms.com</a>
                                </div>
                                <!--end contact-box -->
                            </div>
                            <!-- end col-4 -->
                        </div>


                        <!-- end row -->
                    </div>
                    <!-- end col-10 -->
                </div>
                <!--end row -->
            </div>
            <!-- end container -->
        </section>
        <!-- end content-section -->
        <div class="google-maps">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3613.1990276756587!2d55.152101614855226!3d25.095123241992706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6b4477bb872d%3A0x9425c951a6fe6872!2sShamal%20Communications!5e0!3m2!1sen!2spl!4v1599929833189!5m2!1sen!2spl"
                    width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false"
                    tabindex="0"></iframe>
        </div>
        <!-- end google-maps -->
        <section class="content-section">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="section-title no-spacing">
                            <h6>Get in touch</h6>
                            <h2>Use the form below to contact <br> Shamal Communications team.

                            </h2>
                        </div>
                        <!-- end section-title -->
                    </div>
                    <!-- end col-4 -->
                    <div class="col-lg-8 offset-lg-2">
                        <div class="contact-form">

                            <h5>{{message}}</h5>
                            <form v-show="showForm" @submit.prevent="submitForm">
                                <div class="row">

                                    <!-- end form-group -->
                                    <div class="form-group col-md-6">
                                        <input v-model="q.name" required type="text" placeholder="Full name">
                                        <input v-model="q.email" type="email" required placeholder="E-mail address">
                                        <input v-model="q.phone" required type="text" placeholder="Phone">
                                    </div>
                                    <!-- end form-group -->
                                    <div class="form-group col-md-6">
                                        <textarea v-model="q.message" required placeholder="Your message"></textarea>
                                    </div>
                                    <!-- end form-group -->
                                    <div class="form-group col-12">

                                        <input type="submit" value="SEND ENQUIRY">
                                    </div>
                                    <!-- end form-group -->
                                </div>
                                <!-- end row -->
                            </form>
                        </div>
                    </div>
                    <!-- end col-8 -->
                </div>
                <!--end row -->
            </div>
            <!-- end container -->
        </section>

    </div>
</template>
<script>

    import axios from 'axios';
    export default {
        props: [],
        data: function() {
            return {
                message: '',
                showForm: true,
                q: {csrf_token: window.__csrf__ }
            }
        },


        methods : {
            submitForm(){
                this.message = 'Sending ...'
                this.showForm = false;
                axios.post('/xhr/contact/', this.q).then(res=>{
                    this.message = res.data;
                })

            }
        }
    }
</script>
<style scoped lang="scss">

    $color: #9a181f;

    .contact {
  background: #fff;
      .txt {
        padding: 25px;
      }
    }



    .section-title {
        text-align: center;
        margin: 0;
    }

    /* CONTACT FORM */
    .contact-form {
        width: 100%;
        display: block;
        margin-top: 50px;

        .form-group {
            width: 100%;
            display: block;
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0;
            }
        }

        span {
            line-height: 65px;
        }

        input[type="text"], input[type="email"] {
            width: 100%;
            display: block;
            margin-bottom: 15px;
        }

        input[type="submit"] {
            float: right;
        }

        textarea {
            height: 223px;
        }
    }

    /* FORM ELEMENTS */
    input[type="text"], input[type="email"], input[type="search"], input[type="password"] {
        width: 100%;
        height: 65px;
        border: 2px solid #d4d4e0;
        padding: 0 30px;
        border-radius: 4px;
    }

    input[type="submit"], input[type="button"], button[type="button"], button[type="submit"] {
        height: 65px;
        border: none;
        background: $color;
        color: #fff;
        font-weight: 800;
        font-size: 13px;
        padding: 0 50px;
        letter-spacing: 1px;
        border-radius: 4px;
    }

    textarea {
        width: 420px;
        max-width: 100%;
        height: 128px;
        border: 2px solid #d4d4e0;
        padding: 30px;
        border-radius: 4px;
    }

    select {
        width: 100%;
        height: 65px;
        border: 2px solid #d4d4e0;
        padding: 0 30px;
        border-radius: 4px;
    }

    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: linear-gradient(45deg, transparent 50%, gray 50%),
        linear-gradient(135deg, gray 50%, transparent 50%),
        linear-gradient(to right, #ccc, #ccc);
        background-position: calc(100% - 30px) 28px,
        calc(100% - 25px) 28px,
        calc(100% - 2.5em) 15px;
        background-size: 5px 5px,
        5px 5px,
        0px 0px;
        background-repeat: no-repeat;
    }

    select:focus {
        background-image: linear-gradient(45deg, gray 50%, transparent 50%),
        linear-gradient(135deg, transparent 50%, gray 50%),
        linear-gradient(to right, #ccc, #ccc);
        background-position: calc(100% - 25px) 26px,
        calc(100% - 30px) 26px,
        calc(100% - 2.5em) 15px;
        background-size: 5px 5px,
        5px 5px,
        0px 0px;
        background-repeat: no-repeat;
        outline: 0;
    }


    select:-moz-focusring {
        color: transparent;
        text-shadow: 0 0 0 #000;
    }


    /* CONTACT BOX */
    .contact-box {
        width: 100%;
        display: block;

        figure {
            width: 100%;
            display: block;
            margin-bottom: 20px;
            position: relative;

            &:before {
                content: "";
                width: 60px;
                height: 60px;
                background: $color;
                position: absolute;
                left: -10px;
                top: -10px;
                opacity: 0.05;
                border-radius: 50%;
            }

            img {
                height: 60px;
            }
        }

        h6 {
            color: $color;
            text-transform: uppercase;
            font-weight: 600;
            font-size: 15px;
            letter-spacing: 1px;
        }

        p {
            color: #1c1c1c;
            font-weight: 300;
        }

        a {
            display: block;
            color: #8a8e96;
            font-weight: 300;
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }
    }
    h2 {
        margin: 20px 0;
    }


    /* GOOGLE MAPS */
    .google-maps {
        width: 100%;
        display: block;
        position: relative;
        background: #444;

        &:after {
            /*content: "";*/
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }

        iframe {
            width: 100%;
            height: 520px;
            display: block;
            border: none;
            mix-blend-mode: hard-light;
        }
    }


    .content-section {
      margin: 40px 0;

    }

    .social-media ul {
      padding: 0;
      list-style: none;
    }
    .social-media ul li {
      display: inline-block;
    }
    .social-media ul li a {
      color: $color;
      font-size: 26px;
      margin: 0 8px;
    }
</style>